<div class="preview-layout" [class.expanded]="expanded">
    <div class="preview-content">
        <nz-flex nzJustify="space-between" nzAlign="flex-start" nzGap="small" nzWrap="wrap">
            <div>
                <h5 nz-typography>Failā nolasītie elektroniskie paraksti</h5>
                <p nz-typography nzType="secondary">Faila metadati; parakstu derīgums netiek pārbaudīts.</p>
            </div>
            @if (!inspectionLoading) {
                @if (inspection; as data) {
                    <div>
                        <nz-tag>{{ data.format }}</nz-tag>
                        <nz-tag class="m-0">Parakstu skaits: {{ data.signatureCount ?? 'nav nosakāms' }}</nz-tag>
                    </div>
                }
            }
        </nz-flex>
        @if (inspectionLoading) {
            <nz-spin nzSimple nzSize="small"></nz-spin>
            <span>Nolasa parakstu informāciju…</span>
        } @else {
            @if (!inspection || inspection.signatureCount == null) {
                <nz-alert class="mb-2" nzType="warning" nzMessage="Parakstu informācija nav nosakāma" nzShowIcon></nz-alert>
            }
            @if (inspection; as data) {
                @for (signature of data.signatures; track $index) {
                    <nz-card class="mb-2" nzSize="small">
                        <nz-flex nzGap="large" nzWrap="wrap">
                            <nz-flex nzVertical>
                                <span nz-typography nzType="secondary">Parakstītājs</span>
                                <strong>{{ signature.signerName || 'Parakstītāja vārds nav nosakāms' }}</strong>
                            </nz-flex>
                            @if (signature.signingTime) {
                                <nz-flex nzVertical>
                                    <span nz-typography nzType="secondary">Parakstīšanas laiks</span>
                                    <span>{{ signature.signingTime }}</span>
                                </nz-flex>
                            }
                        </nz-flex>
                    </nz-card>
                }
                @for (warning of data.warnings; track $index) {
                    <p nz-typography nzType="secondary">{{ warning }}</p>
                }
                @if (data.entries.length) {
                    <h5 nz-typography class="mt-3">Konteinera faili</h5>
                    @for (entry of data.entries; track entry.name) {
                        <nz-card class="mb-2" nzSize="small">
                            <div class="container-entry">
                                <span>
                                    <strong>{{ entry.name }}</strong>
                                </span>
                                <button
                                    type="button"
                                    nz-button
                                    [nzType]="selectedEntryName === entry.name ? 'primary' : 'default'"
                                    (click)="selectEntry(entry.name)"
                                >
                                    @if (canPreview(entry.name)) {
                                        <span nz-icon nzType="search" nzTheme="outline"></span>
                                    }
                                    {{ canPreview(entry.name) ? 'Apskatīt' : 'Izvēlēties' }}
                                </button>
                            </div>
                        </nz-card>
                    }
                }
            }
            @for (error of inspectionErrors; track $index) {
                <p nz-typography nzType="secondary">{{ error }}</p>
            }
        }
        @for (error of downloadErrors; track $index) {
            <nz-alert class="mb-2" nzType="error" nzShowIcon [nzMessage]="error"></nz-alert>
        }
        @if (selectedEntryName) {
            <p>
                Izvēlētais fails: <strong>{{ selectedEntryName }}</strong>
            </p>
            @if (!canPreview(selectedEntryName)) {
                <p nz-typography nzType="secondary">Šim failam priekšskats nav pieejams; to var lejupielādēt.</p>
            }
        }
        @if (showViewer) {
            <cl-file-viewer
                [class.expanded]="expanded"
                [fileName]="viewedFileName"
                [fileIdentity]="selectedEntryName"
                [loadFileMetadata]="loadFileMetadata"
            ></cl-file-viewer>
        }
    </div>
    <div class="modal-footer preview-actions">
        <nz-flex class="w-100" nzJustify="space-between" nzAlign="center" nzGap="small" nzWrap="wrap">
            <button type="button" nz-button [attr.aria-pressed]="expanded" (click)="toggleExpanded()">
                {{ expanded ? 'Atjaunot' : 'Palielināt' }}
            </button>
            <nz-flex nzJustify="flex-end" nzGap="small" nzWrap="wrap">
                <button type="button" nz-button [nzLoading]="downloadLoading" (click)="download()">
                    <span nz-icon nzType="download"></span>
                    {{ isContainer ? 'Lejupielādēt oriģinālu' : 'Lejupielādēt' }}
                </button>
                @if (isContainer && selectedEntryName) {
                    <button type="button" nz-button [disabled]="downloadLoading" (click)="download(selectedEntryName)">
                        <span nz-icon nzType="download"></span>
                        Lejupielādēt izvēlēto failu
                    </button>
                }
                <button type="button" nz-button (click)="close()">Aizvērt</button>
            </nz-flex>
        </nz-flex>
    </div>
</div>
